import React from 'react';
import { Icon } from './Icon.js';
export const IconBeerMug = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M18 10H22V17H18", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M4 7.5V21H18V7.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M16.5 3H5.5C4.11929 3 3 4.11929 3 5.5C3 6.88071 4.11929 8 5.5 8H8V13C8 14.1046 8.89543 15 10 15C11.1046 15 12 14.1046 12 13V8H16.5C17.8807 8 19 6.88071 19 5.5C19 4.11929 17.8807 3 16.5 3Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconBeerMug.js.map